// extracted by mini-css-extract-plugin
export default {"media":"Icone_media__ASUH9","media--intera":"Icone_media--intera__GJqrl","media--vuoto":"Icone_media--vuoto__+6I-1"};